import React, {Component} from 'react';
import {connect} from 'react-redux';
import {createLocation} from 'history';
import { isEmpty } from '../../../../../shared/services/lodashInJS.js';

import {generate} from '../../../../routes.js';
import MustBeAdminOrBm from '../../../../components/Must/MustBeAdminOrBm.jsx';
import SearchContainer from '../../../Search/SearchContainer.jsx';
import {searchPurchasers} from '../../../Search/actions.js';
import conf from '../../../../conf.js';

class PurchaserSearchContainer extends Component {
  static searchRouteName = 'purchasers.search.results';

  search = (data) => {
    this.props.history.push(createLocation(
      generate({
        name: PurchaserSearchContainer.searchRouteName,
        search: this.flattenSearchObject({
          ...data,
          page: 1
        })
      })
    ));
  };

  flattenSearchObject = (data) => {
    const {...output} = data;
    delete output.target;

    return output;
  };

  expandSearchObject = (search, currentUniverseId) => {
    const {keywords, universe, page, ...output} = search;
    if (!isEmpty(keywords)) {
      output.keywords = !Array.isArray(keywords) ? [keywords] : keywords;
    }

    output.universe = (universe || currentUniverseId).toString();
    output.page = (page || 1).toString();
    output.target = conf.search.targets.purchasers;

    return output;
  };

  render() {
    return (
      <SearchContainer
        expandSearchObject={this.expandSearchObject}
        flattenSearchObject={this.flattenSearchObject}
        search={this.search}
        routes={this.props.route.routes}
        dispatchSearch={this.props.searchPurchasers}
        searchRouteName={PurchaserSearchContainer.searchRouteName}
        searchTarget={conf.search.targets.purchasers}
      />
    );
  }
}

export default MustBeAdminOrBm(
  connect(
    (state) => ({
      search: state.search.search
    }),
    (dispatch) => ({
      searchPurchasers: (model) => dispatch(searchPurchasers(model))
    })
  )(PurchaserSearchContainer)
);